import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { CheckIcon } from 'lucide-react';

const TrueFalseWidget = ({ onAnswer, disabled, initialValue = null }) => {
  const [selected, setSelected] = useState(initialValue);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setSelected(initialValue);
    setHasSubmitted(false);
  }, [initialValue]);

  const handleSelect = (answer) => {
    setSelected(answer);
    setHasSubmitted(true);
    setTimeout(() => {
      onAnswer({ value: answer });
    }, 300);
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={() => handleSelect('true')}
        disabled={disabled || hasSubmitted}
        variant={selected === 'true' ? 'primary' : 'outline'}
        className="flex-1 h-9 text-sm"
      >
        {selected === 'true' && <CheckIcon className="h-3.5 w-3.5 mr-1.5" />}
        True
      </Button>
      <Button
        onClick={() => handleSelect('false')}
        disabled={disabled || hasSubmitted}
        variant={selected === 'false' ? 'primary' : 'outline'}
        className="flex-1 h-9 text-sm"
      >
        {selected === 'false' && <CheckIcon className="h-3.5 w-3.5 mr-1.5" />}
        False
      </Button>
    </div>
  );
};

export default TrueFalseWidget;
